import { Edit, RestartAlt } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import { useState } from "react";


export default function EditableTextbox({ id, label = 'Amount', variant = 'outlined', value, defaultValue, onChange, size = "small", type="text" }) {

   const [isEditing, setIsEditing] = useState(false);

   return <div className="grid grid-cols-[1fr,auto] gap-1">
      <TextField
         id={id}
         label={label}
         variant={variant}
         fullWidth
         size={size}
         value={value}
         onChange={e => onChange(e.target.value)}
         type={type}
         disabled={!isEditing}
      />
      <div className="flex items-center">
         {
            isEditing ? <IconButton
               size="small"
               onClick={() => {
                  onChange(defaultValue);
                  setIsEditing(false);
               }}
            >
               <RestartAlt fontSize="small" />
            </IconButton>: <IconButton size="small" onClick={() => setIsEditing(true)}>
               <Edit fontSize="small" />
            </IconButton>
         }
      </div>
   </div>
}